export const OBJECTIVES_ENDPOINTS = {
  GET: (documentId: string) => `/v1/documents/${documentId}/objectives`,
  EXTRACT: (documentId: string) => `/v1/documents/${documentId}/objectives`,
  LESSONS: (documentId: string) => `/v1/documents/${documentId}/lessons`,
  CONTEXT: (objectiveId: string) => `/v1/objectives/${objectiveId}/context`,
  RUN_BULK: "/v1/objectives/run",
} as const;
